import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const AdminLogin = () => {
  const { login, user, checking } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (checking) return null;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-[#FAFAFA]" data-testid="admin-login-root">
      <div className="mx-auto grid min-h-screen max-w-[1400px] grid-cols-1 gap-0 px-4 sm:px-6 md:grid-cols-2">
        <div className="hidden flex-col justify-between border-r border-white/10 py-16 pr-16 md:flex">
          <div className="font-[Unbounded,sans-serif] text-sm uppercase tracking-[0.32em] text-[#A855F7]">
            Black Box Music
          </div>
          <div>
            <h1 className="font-[Unbounded,sans-serif] text-5xl uppercase leading-[0.95] tracking-tight">
              Studio<br />Access.
            </h1>
            <p className="mt-6 max-w-md font-mono text-sm leading-relaxed text-[#A1A1AA]">
              Manage the weekly schedule, curate featured selections, and update station metadata.
            </p>
          </div>
          <div className="font-mono text-sm font-bold uppercase tracking-[0.28em] text-[#A855F7]">
            Restricted // Authorized personnel only
          </div>
        </div>

        <div className="flex items-center py-16 md:pl-16">
          <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
            <div className="font-mono text-sm font-bold uppercase tracking-[0.28em] text-[#A855F7]">§ Login</div>
            <h2 className="mt-2 font-[Unbounded,sans-serif] text-3xl uppercase tracking-tight">Sign In</h2>

            <label className="mt-8 block">
              <span className="font-mono text-sm font-bold uppercase tracking-[0.22em] text-[#FAFAFA]">Email</span>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-login-email"
                className="mt-2 w-full border border-white/10 bg-transparent px-4 py-3 font-mono text-sm text-[#FAFAFA] outline-none transition-colors focus:border-[#A855F7]"
                placeholder="admin@blackboxmusic.com"
              />
            </label>

            <label className="mt-6 block">
              <span className="font-mono text-sm font-bold uppercase tracking-[0.22em] text-[#FAFAFA]">Password</span>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-login-password"
                className="mt-2 w-full border border-white/10 bg-transparent px-4 py-3 font-mono text-sm text-[#FAFAFA] outline-none transition-colors focus:border-[#A855F7]"
                placeholder="••••••••"
              />
            </label>

            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="mt-8 w-full border border-[#A855F7] bg-[#A855F7] px-4 py-3 font-mono text-sm font-bold uppercase tracking-[0.28em] text-black transition-colors hover:bg-transparent hover:text-[#A855F7] disabled:opacity-50"
            >
              {loading ? "Signing in..." : "Enter Studio"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
